<div class="welcome">

  <fa-icon
    class="welcome__close"
    [icon]="['fas', 'times']"
    size="lg"
    title="Close"
    (click)="handleCancelClick()">
  </fa-icon>

  <div class="m-4 text-16">
    Welcome to the {{ organization.name }} Group Network!    
  </div>

  <img class="m-4" *ngIf="organization.group_logos.default" [src]="organization.group_logos.default">

  <div class="m-4" mat-dialog-actions>

    <button
      class="welcome__button"
      app-button
      buttonType="outline"
      buttonTheme="light"
      (click)="handleCancelClick()">
        No, thank you
    </button>

    <button
      class="welcome__button"
      app-button
      buttonType="primary"
      cdkFocusInitial
      (click)="handleJoinClick()">
        Join Group
    </button>

  </div>

</div>